import type { IContractBook, SupportedChainId } from "@eulerxyz/core-sdk"
import type { ContractFunctionConfig } from "@eulerxyz/evc-sdk"
import { BaseTransactionFactory } from "./BaseTransactionFactory"
import {
  SwapVerifierDebtMaxTransactionItem,
  SwapVerifierSkimMinTransaction,
  type TransactionItemUnion,
  type TransactionItems,
  isSwapVerifierDebtMaxTransactionItem,
  isSwapVerifierSkimMinTransactionItem,
} from "./types"

export class SwapVerifierTransactionFactory extends BaseTransactionFactory {
  customData: {
    [key: string]: any
  }

  constructor(chainId: SupportedChainId, contractBook: IContractBook) {
    super(chainId, contractBook)
    this.customData = {}
  }

  typeGuardConvertMultiple(
    _transactions: TransactionItems, // todo: modify this to use more specific type
  ): ContractFunctionConfig[] {
    const contractCallReadyTxs: ContractFunctionConfig[] = []
    for (const tx of _transactions) {
      const call = this.typeGuardConvertSingle(tx)
      contractCallReadyTxs.push(call)
    }
    return contractCallReadyTxs
  }

  typeGuardConvertSingle(
    _transaction: TransactionItemUnion, // todo: modify this to use more specific type
  ): ContractFunctionConfig {
    if (isSwapVerifierSkimMinTransactionItem(_transaction)) {
      return this.convertSwapVerifierSkimMin(_transaction)
    }
    if (isSwapVerifierDebtMaxTransactionItem(_transaction)) {
      return this.convertSwapVerifierDebtMax(_transaction)
    }

    throw this.errorUnsupportedTransactionType(_transaction)
  }

  convertSwapVerifierSkimMin(
    _transaction: SwapVerifierSkimMinTransaction,
  ): ContractFunctionConfig<
    typeof this.contractBook.swapVerifier.abi,
    "verifyAmountMinAndSkim"
  > {
    return {
      abi: this.contractBook.swapVerifier.abi,
      functionName: "verifyAmountMinAndSkim",
      value: 0n,
      address: _transaction.verifierAddress,
      onBehalfOfAccount: _transaction.account,
      args: [
        _transaction.vault,
        _transaction.account,
        BigInt(_transaction.amount),
        BigInt(_transaction.deadline),
      ],
    }
  }

  convertSwapVerifierDebtMax(
    _transaction: SwapVerifierDebtMaxTransactionItem,
  ): ContractFunctionConfig<
    typeof this.contractBook.swapVerifier.abi,
    "verifyDebtMax"
  > {
    return {
      abi: this.contractBook.swapVerifier.abi,
      functionName: "verifyDebtMax",
      value: 0n,
      address: _transaction.verifierAddress,
      onBehalfOfAccount: _transaction.account,
      args: [
        _transaction.vault,
        _transaction.account,
        BigInt(_transaction.amount),
        BigInt(_transaction.deadline),
      ],
    }
  }
}
